'use client'

import { useTranslations } from 'next-intl'

import { ReceiptForm } from '@/features/update-receipt-information'
import { ScrollProvider } from '@/shared/lib'

export const ReceiptForFee = () => {
  const t = useTranslations('signup_bank_account')

  return (
    <ScrollProvider>
      <div className="mt-10 space-y-4">
        <h3 className="typo-body1 font-semibold text-black">
          {t('receipt_section_title')}
        </h3>
        <ReceiptForm scrollBlock="center" />
      </div>
    </ScrollProvider>
  )
}
